import { InMemoryCache } from '@apollo/client/cache';

/**
 * Reactive variables
 */
import { isLoggedInVar, isTourActiveVar, currentUserVar } from './variables';

/**
 * Utils
 */
import { firstCharToUppercase } from '@/lib/utils';

/**
 * Types
 */
import {
  ProgramQuery,
  ProgramSkillsQuery,
  namedOperations
} from '@/graphql/generated';

export const cache: InMemoryCache = new InMemoryCache({
  typePolicies: {
    Major: {
      fields: {
        name(name: string) {
          return name
            .split(' ')
            .map(majorName => firstCharToUppercase(majorName))
            .join(' ');
        }
      }
    },
    DataValueEntity: {
      keyFields: ['name']
    },
    Query: {
      fields: {
        [namedOperations.Query.program]: {
          merge(existing = {}, incoming: ProgramQuery['program']) {
            return { ...existing, ...incoming };
          }
        },
        [namedOperations.Query.programSkills]: {
          merge(existing = {}, incoming: ProgramSkillsQuery['program']) {
            return { ...existing, ...incoming };
          }
        },
        currentUser() {
          return currentUserVar();
        },
        isLoggedIn() {
          return isLoggedInVar();
        },
        isTourActive() {
          return isTourActiveVar();
        }
      }
    }
  }
});
